@if(isReady){
  <lib-app-shell [application]="frameworkService.currentApp" />
} @else{
  <div class="loading-container">
    <h2>Loading Hayagriva...</h2>
  </div>
}

<!-- Modal components for cascading modals -->
<app-default-modal [level]="1"></app-default-modal>
<app-default-modal [level]="2"></app-default-modal>
<app-default-modal [level]="3"></app-default-modal>

<app-off-canvas-collective></app-off-canvas-collective>